import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import PanelLayout from './panel_layout'
import GroupListItem from '../group_list_item'
import ScrollableList from '../scrollable_list'
import GroupListItemPlaceholder from '../placeholder/group_list_item_placeholder'
import { fetchGroupsByTab } from '../../actions/groups'

class GroupsPanel extends ImmutablePureComponent {
  componentDidMount() {
    const { isFetched, isLoading } = this.props
    if (!isFetched && !isLoading) this.props.onFetch()
  }

  render() {
    const { groupIds, groupType, max, noPanel, padded } = this.props

    const count = !!groupIds ? groupIds.count() : 0
    const maxCount = max || 4

    if (count === 0) return null

    return (
      <PanelLayout
        noPanel={noPanel}
        title={groupType === 'member' ? "Your groups" : "Featured Groups"}
        headerButtonTitle="Show all"
        headerButtonTo={groupType === 'member' ? '/groups/browse/member' : '/groups/browse/featured'}
        footerButtonTitle={count > maxCount ? "Show all" : undefined}
        footerButtonTo={count > maxCount ? `/groups/browse/${groupType}` : undefined}
        noPadding
      >
        <ScrollableList
          scrollKey='groups_panel'
          placeholderComponent={GroupListItemPlaceholder}
          placeholderCount={6}
        >
          {
            groupIds && groupIds.sortBy(Math.random).slice(0, maxCount).map((groupId, i) => (
              <GroupListItem
                key={`group-panel-item-${groupId}`}
                id={groupId}
                padded={padded}
                isLast={groupIds.count() - 1 === i}
              />
            ))
          }
        </ScrollableList>
      </PanelLayout>
    )
  }

}

const mapStateToProps = (state, { groupType }) => ({
  groupIds: state.getIn(['group_lists', groupType, 'items']),
  isLoading: state.getIn(['group_lists', groupType, 'isLoading']),
  isFetched: state.getIn(['group_lists', groupType, 'isFetched']),
})

const mapDispatchToProps = (dispatch, { groupType }) => ({
  onFetch() {
    dispatch(fetchGroupsByTab(groupType))
  },
})

GroupsPanel.propTypes = {
  groupIds: ImmutablePropTypes.list,
  isLazy: PropTypes.bool, 
  shouldLoad: PropTypes.bool,
  groupType: PropTypes.string,
}

GroupsPanel.defaultProps = {
  groupType: 'member'
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupsPanel)
